const infos = {

  // Shop-Variablen
  title: 'liebeszuhause',
  name: 'liebeszuhause.de',
  url: 'https://www.liebeszuhause.de/',
  email: 'hallo@liebeszuhause.de',
  //telephone: '0202/43044332',
  telephone: undefined as string | undefined,
  fax: '0202/43044350',
  publicher: 'liebeszuhause',
  priceRange: '$', // Wie Teuer sind wir?   1-5  // 1 = Billig  2 = Normal  5 = SUPER-TEUER!!!

  // SHOP INFOS
  description: 'Finden Sie in unserem Shop schöne Dekoartikel für Ihr Zuhause!',
  titleAlternate: 'liebeszuhause',
  host: 'www.liebeszuhause.de',
  locale: 'de_DE',
  currency: 'EUR',

  // LEGAL INFOS
  legalowner: 'Angelina Minardi',
  legalname: 'liebeszuhause.de',
  street: 'Alfredstr. 18',
  postalcode: '42281',
  locality: 'Wuppertal',
  region: 'Nordrhein-Westfalen',
  regionCode: 'DE-NW',
  countryCode: 'DE',

  registergericht: null as string | null, // 'Amtsgericht ???'
  registernummer: null as string | null, // 'HRB ?????'
  umsatzsteuernr: 'DE 355655005',

  // Konfiguration
  paymentAfterCheckout: false as boolean, // true = Zahlung nach Bestellung, false = Zahlung vor Bestellung
  siteId: 2,
  containerId: "ALFkVkDK",

} as const

export default infos
